const initialState = {
    selectedTabReward: '',
};

const rewardsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SELECTED_TAB_REWARD':
            return {
                ...state,
                selectedTabReward: action.payload,
            };
        default:
            return state;
    }
};

export default rewardsReducer;